import React, { Component } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

// A searchable organisation picker built on react-select. When a `name` is
// given it renders a hidden input, so the selected organisation id submits
// with the surrounding (server-rendered) form.
export default class OrganizationSearchSelect extends Component {
  static propTypes = {
    organizations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    organizations: [],
    placeholder: 'Search for an organisation',
  }

  handleChange = (option) => {
    if (this.props.onChange) {
      this.props.onChange(option)
    }
  }

  render() {
    return (
      <Select
        getOptionLabel={(option) => option['name']}
        getOptionValue={(option) => option['id']}
        name={this.props.name}
        placeholder={this.props.placeholder}
        options={this.props.organizations}
        noOptionsMessage={() => 'No organisations found.'}
        styles={{
          input: () => ({
            height: '2rem'
          })
        }}
        onChange={this.handleChange}
      />
    )
  }
}
